export const legacyPaymentOptionsLanding = [
  { label: 'Home', url: '/' },
  { label: 'Legacy Payment Options', url: '/legacy-payment-options' },
];

// Maintenance Schedule
export const MAINTENANCE_SCHEDULE_LIST_ROUTE =
  '/legacy-payment-options/maintenance-schedule';
export const MAINTENANCE_SCHEDULE_NEW_ROUTE =
  '/legacy-payment-options/maintenance-schedule/new';

export const viewMaintenanceSchedule = [
  ...legacyPaymentOptionsLanding,
  { label: 'Maintenance Schedule', url: MAINTENANCE_SCHEDULE_LIST_ROUTE },
];

export const addMaintenanceSchedule = [
  ...viewMaintenanceSchedule,
  { label: 'New', url: MAINTENANCE_SCHEDULE_NEW_ROUTE },
];

// Contextual Messages
export const LEGACY_CONTEXTUAL_MESSAGES_LIST_ROUTE =
  '/legacy-payment-options/contextual-messages';
export const LEGACY_CONTEXTUAL_MESSAGES_NEW_ROUTE =
  '/legacy-payment-options/contextual-messages/new';
export const LEGACY_CONTEXTUAL_MESSAGES_UPDATE_ROUTE =
  '/legacy-payment-options/contextual-messages/update';

export const viewLegacyContextualMessages = [
  ...legacyPaymentOptionsLanding,
  {
    label: 'Contextual Messages',
    url: LEGACY_CONTEXTUAL_MESSAGES_LIST_ROUTE,
  },
];

export const addLegacyContextualMessages = [
  ...viewLegacyContextualMessages,
  { label: 'New', url: LEGACY_CONTEXTUAL_MESSAGES_NEW_ROUTE },
];

export const updateLegacyContextualMessages = (id) => [
  ...viewLegacyContextualMessages,
  { label: 'Update', url: `${LEGACY_CONTEXTUAL_MESSAGES_LIST_ROUTE}/${id}` },
];

// Config Module
export const LEGACY_CONFIGURATION_MODULE_LIST_ROUTE =
  '/legacy-payment-options/configuration-module';
export const LEGACY_CONFIGURATION_MODULE_UPDATE_ROUTE =
  '/legacy-payment-options/configuration-module/update';

export const viewConfigurationModule = [
  ...legacyPaymentOptionsLanding,
  {
    label: 'Configuration Module',
    url: LEGACY_CONFIGURATION_MODULE_LIST_ROUTE,
  },
];

export const updateConfigurationModule = (filePath) => [
  ...viewConfigurationModule,
  {
    label: 'Update',
    url: `${LEGACY_CONFIGURATION_MODULE_LIST_ROUTE}/${filePath}`,
  },
];

// Config Module
export const LEGACY_CACHE_RELOAD_LIST_ROUTE =
  '/legacy-payment-options/cache-reload-module';

export const viewCacheReloadModule = [
  ...legacyPaymentOptionsLanding,
  {
    label: 'Cache Reload Module',
    url: LEGACY_CACHE_RELOAD_LIST_ROUTE,
  },
];
